import React, { Fragment, useState, ChangeEvent } from "react";
import {
  Grid,
  Collapse,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { Link } from "react-router-dom";
import FontAwesome from "../UiStyle/FontAwesome";
import { totalPrice } from "../../utils";

// Images
import visa from "../../images/icon/visa.png";
import mastercard from "../../images/icon/mastercard.png";
import skrill from "../../images/icon/skrill.png";
import paypal from "../../images/icon/paypal.png";

import CheckWrap from "../CheckWrap";
import { ProductItem } from "../../store/actions/action";

// 🧾 Props
interface CheckoutSectionProps {
  cartList: (ProductItem & { qty?: number })[];
}

// 💳 Card Type
interface CardType {
  title: string;
  img: string;
}

const cardType: CardType[] = [
  { title: "visa", img: visa },
  { title: "mastercard", img: mastercard },
  { title: "skrill", img: skrill },
  { title: "paypal", img: paypal },
];

const CheckoutSection: React.FC<CheckoutSectionProps> = ({ cartList }) => {
  // 🔹 Accordion tabs
  const [tabs, setExpanded] = useState({
    cupon: false,
    billing_adress: false,
    payment: true,
  });

  // 🔹 Form state
  const [forms, setForms] = useState({
    cupon_key: "",
    fname: "",
    lname: "",
    country: "",
    dristrict: "",
    address: "",
    post_code: "",
    email: "",
    phone: "",
    note: "",
    payment_method: "cash",
    card_type: "",
    fname2: "",
    lname2: "",
    country2: "",
    dristrict2: "",
    address2: "",
    post_code2: "",
    email2: "",
    phone2: "",
    card_holder: "",
    card_number: "",
    cvv: "",
    expire_date: "",
  });

  const [dif_ship, setDifShip] = useState(false);

  // 🔸 Toggle tab
  const faqHandler = (name: keyof typeof tabs) => {
    setExpanded({
      cupon: false,
      billing_adress: false,
      payment: false,
      [name]: !tabs[name],
    });
  };

  // 🔸 Handle input change
  const changeHandler = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | { name?: string; value: unknown }>
  ) => {
    const { name, value } = e.target;
    if (name) {
      setForms((prev) => ({ ...prev, [name]: value }));
    }
  };

  return (
    <Fragment>
      <Grid className="checkoutWrapper section-padding">
        <Grid className="container" container spacing={3}>
          {/* Left column */}
          <Grid item md={6} xs={12}>
            <div className="check-form-area">
              {/* Coupon Section */}
              <Grid className="cuponWrap checkoutCard">
                <Button
                  className="collapseBtn"
                  fullWidth
                  onClick={() => faqHandler("cupon")}
                >
                  Have a coupon ? Click here to enter your code.
                  <FontAwesome name={tabs.cupon ? "minus" : "plus"} />
                </Button>
                <Collapse in={tabs.cupon} timeout="auto" unmountOnExit>
                  <Grid className="chCardBody">
                    <p>If you have coupon code, please apply it</p>
                    <form className="cuponForm">
                      <TextField
                        fullWidth
                        type="text"
                        className="formInput radiusNone"
                        value={forms.cupon_key}
                        name="cupon_key"
                        onChange={changeHandler}
                      />
                      <Button className="cBtn cBtnBlack">Apply</Button>
                    </form>
                  </Grid>
                </Collapse>
              </Grid>

              {/* Billing Section */}
              <Grid className="cuponWrap checkoutCard">
                <Button
                  className="collapseBtn"
                  fullWidth
                  onClick={() => faqHandler("billing_adress")}
                >
                  Billing Address
                  <FontAwesome
                    name={tabs.billing_adress ? "minus" : "plus"}
                  />
                </Button>
                <Collapse in={tabs.billing_adress} timeout="auto" unmountOnExit>
                  <Grid className="chCardBody">
                    <form className="cuponForm">
                      <Grid container spacing={3}>
                        <Grid item sm={6} xs={12}>
                          <TextField
                            fullWidth
                            label="First Name"
                            name="fname"
                            value={forms.fname}
                            onChange={changeHandler}
                            InputLabelProps={{ shrink: true }}
                            className="formInput radiusNone"
                          />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                          <TextField
                            fullWidth
                            label="Last Name"
                            name="lname"
                            value={forms.lname}
                            onChange={changeHandler}
                            InputLabelProps={{ shrink: true }}
                            className="formInput radiusNone"
                          />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                          <FormControl fullWidth variant="filled">
                            <InputLabel>Country</InputLabel>
                            <Select
                              value={forms.country}
                              name="country"
                              onChange={changeHandler}
                            >
                              <MenuItem value="">None</MenuItem>
                              <MenuItem value="Bangladesh">Bangladesh</MenuItem>
                              <MenuItem value="USA">USA</MenuItem>
                              <MenuItem value="UK">UK</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                          <TextField
                            fullWidth
                            label="District"
                            name="dristrict"
                            value={forms.dristrict}
                            onChange={changeHandler}
                            InputLabelProps={{ shrink: true }}
                            className="formInput radiusNone"
                          />
                        </Grid>

                        {/* Address */}
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Address"
                            name="address"
                            value={forms.address}
                            onChange={changeHandler}
                            InputLabelProps={{ shrink: true }}
                            className="formInput radiusNone"
                          />
                        </Grid>

                        {/* Checkbox */}
                        <Grid item xs={12}>
                          <FormControlLabel
                            className="checkBox"
                            control={
                              <Checkbox
                                checked={dif_ship}
                                onChange={() => setDifShip(!dif_ship)}
                                color="primary"
                              />
                            }
                            label="Ship to a different address?"
                          />
                        </Grid>

                        {/* Notes */}
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            multiline
                            label="Order Notes"
                            placeholder="Note about your order"
                            name="note"
                            value={forms.note}
                            onChange={changeHandler}
                            InputLabelProps={{ shrink: true }}
                            className="formInput radiusNone note"
                          />
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                </Collapse>
              </Grid>

              {/* Payment Section */}
              <Grid className="cuponWrap checkoutCard">
                <Button
                  className="collapseBtn"
                  fullWidth
                  onClick={() => faqHandler("payment")}
                >
                  Payment Method
                  <FontAwesome name={tabs.payment ? "minus" : "plus"} />
                </Button>
                <Grid className="chCardBody">
                  <Collapse in={tabs.payment} timeout="auto">
                    <RadioGroup
                      className="paymentMethod"
                      name="payment_method"
                      value={forms.payment_method}
                      onChange={changeHandler}
                    >
                      <FormControlLabel
                        value="cash"
                        control={<Radio color="primary" />}
                        label="Payment By Card"
                      />
                      <FormControlLabel
                        value="card"
                        control={<Radio color="primary" />}
                        label="Cash On Delivery"
                      />
                    </RadioGroup>

                    <Collapse in={forms.payment_method === "cash"} timeout="auto">
                      <Grid className="cardType">
                        {cardType.map((item) => (
                          <Grid
                            key={item.title}
                            className={`cardItem ${
                              forms.card_type === item.title ? "active" : ""
                            }`}
                            onClick={() =>
                              setForms({ ...forms, card_type: item.title })
                            }
                          >
                            <img src={item.img} alt={item.title} />
                          </Grid>
                        ))}
                      </Grid>
                      <Grid>
                        <CheckWrap />
                      </Grid>
                    </Collapse>

                    <Collapse in={forms.payment_method === "card"} timeout="auto">
                      <Grid className="cardType">
                        <Link
                          to="/order_received"
                          className="cBtn cBtnLarge cBtnTheme mt-20 ml-15"
                        >
                          Proceed to Checkout
                        </Link>
                      </Grid>
                    </Collapse>
                  </Collapse>
                </Grid>
              </Grid>
            </div>
          </Grid>

          {/* Right column */}
          <Grid item md={6} xs={12}>
            <Grid className="cartStatus">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid className="cartTotals">
                    <h4>Cart Total</h4>
                    <Table>
                      <TableBody>
                        {cartList.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>
                              {item.title} ${item.price} x {item.qty}
                            </TableCell>
                            <TableCell align="right">
                              ${Number(item.qty || 1) * Number(item.price || 0)}
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow className="totalProduct">
                          <TableCell>Total Item</TableCell>
                          <TableCell align="right">{cartList.length}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Sub Price</TableCell>
                          <TableCell align="right">${totalPrice(cartList)}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Total Price</TableCell>
                          <TableCell align="right">${totalPrice(cartList)}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default CheckoutSection;
